// With auth disabled (local testing) there is no session: the email saved in
// Settings ("Dashboard User") stands in for the user. kast-common's bypass
// email store, under the key Settings always used ("userEmail"). The route
// gate asks for it (BypassEmailGate) until it is set.

import { createBypassEmail } from "@jkast90/kast-common/auth";
import { getAuthEnabled, getBypassEmail } from "../settings";

export const bypassEmail = createBypassEmail();

// The Settings "Bypass Email" field is saved apart ("bypass_email") and, with
// auth off, has always been the user on the next load: copy it in first, so
// the gate does not ask again for an email Settings already holds.
if (!getAuthEnabled()) {
  const saved = getBypassEmail();
  if (saved) bypassEmail.set(saved);
}
